import type { ZFilterGroup } from "src/business/queryBuilder/types/ZFilterApiTypes";
import type { ZFilterSearchSortItem } from "src/business/queryBuilder/types/ZFilterSearchTypes";
import { getApiUrl } from "src/common/api/getUrl";
import { dataParser } from "src/common/dataParser";
import { rest } from "src/common/rest";
import { RtResponse } from "src/components/ReactiveTable/RtResponse";
import z from "zod";

import {
  ZCatalogRecord,
  zCatalogRecord,
  ZCatalogRecordToSave,
} from "./ZCatalogRecord";

export const urlCatalogs = (path: string) => getApiUrl(`/core/catalogs${path}`);

type SearchCatalogCardsRequest = {
  classifierId?: string;
  classId?: string;
  query?: string;
  filters: ZFilterGroup[];
  tree?: {
    classifierId?: string;
    parentId?: string;
    catalogId?: string;
  };
  page: {
    size: number;
    offset: number;
  };
  sort?: ZFilterSearchSortItem[];
};

export const searchCatalogCards = async (
  catalogId: string,
  data: SearchCatalogCardsRequest,
): Promise<RtResponse<ZCatalogRecord>> => {
  const resp = await rest.post(urlCatalogs(`/${catalogId}/cards/filter`), data);
  const zResult = z.object({
    content: zCatalogRecord.array(),
    pagination: z.object({
      totalElements: z.number(),
    }),
  });
  const parsed = dataParser(
    () => zResult.parse(resp.data),
    "searchCatalogCards",
  );
  return {
    rows: parsed.content,
    totalRows: parsed.pagination.totalElements,
  };
};

export const loadCatalogRecord = async (
  recordId: string,
): Promise<ZCatalogRecord> => {
  const resp = await rest.get(urlCatalogs(`/cards/${recordId}`));
  return dataParser(() => zCatalogRecord.parse(resp.data), "loadCatalogRecord");
};

export const createCatalogRecord = async (
  catalogId: string,
  data: ZCatalogRecordToSave,
): Promise<ZCatalogRecord> => {
  const resp = await rest.post(urlCatalogs(`/${catalogId}/cards`), data);
  return dataParser(
    () => zCatalogRecord.parse(resp.data),
    "createCatalogRecord",
  );
};

export const updateCatalogRecord = async (
  recordId: string,
  data: ZCatalogRecordToSave,
): Promise<ZCatalogRecord> => {
  const resp = await rest.put(urlCatalogs(`/cards/${recordId}`), data);
  return dataParser(
    () => zCatalogRecord.parse(resp.data),
    "updateCatalogRecord",
  );
};

export const deleteCatalogRecord = async (recordId: string) => {
  await rest.delete(urlCatalogs(`/cards/${recordId}`));
};
